import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

/**
 * Returns year quarter of date. f.e. Q1 22
 */
@Pipe({ name: 'rdYearQuarter' })
export class RdYearQuarterPipe implements PipeTransform {
  /**
   * Transforms the date input to for example 'Q2 2022'
   * @param input Input
   * @param quarterChar Quarter char ('Q')
   * @param yearsDigits Amount of years digits
   */
  transform(input: any, quarterChar = 'Q', yearsDigits = 2): string {
    let date: Date = null;

    if (input) {
      if (typeof (input) === 'string') {
        date = moment(input).toDate();
      }
      else if (input instanceof Date) {
        date = input;
      }

      if (date) {
        const fullYear: string = date.getFullYear().toString();
        const year: string = fullYear.substring(fullYear.length - yearsDigits, fullYear.length);

        if (!quarterChar) {
          return `${year}`;
        }

        const quarter: number = Math.floor((date.getMonth() + 3) / 3);

        return `${quarterChar}${quarter} ${year}`;
      }
    }

    return '';
  }
}
